// Valores estruturais (não-cor) do app-shell — cores/radius/sombras vêm de
// `theme.torq`/tokens.ts (ver src/shared/themes) para se adaptarem a light/dark.
export const layoutTokens = {
  sidebarOpen: 200,
  // Não reduzir abaixo de 72: é a largura mínima que ainda comporta o
  // avatar (56px) + padding lateral (8px de cada lado) sem estourar,
  // já que o avatar aparece tanto no modo rail quanto no expandido.
  sidebarClosed: 72,
  submenuWidth: 290,
  logoHeaderHeight: 68,

  pagePadding: 24,
};
